import { useEffect, useState } from "react";
import { Quote, Star } from "lucide-react";
import { api } from "../../lib/api";
import { Reveal, SectionHeading } from "../Reveal";

export function TrustBar() {
  const [testimonials, setTestimonials] = useState([]);

  useEffect(() => {
    api.get("/content/testimonials").then((r) => setTestimonials(r.data || [])).catch(() => {});
  }, []);

  return (
    <section id="trust" data-testid="trust-section" className="bg-bone py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeading
          center
          chapter={["00", "Proof"]}
          title={
            <>
              Results our clients can{" "}
              <em className="font-editorial font-medium italic text-gold-dark">point to.</em>
            </>
          }
        />

        <div className="mt-14 grid gap-6 md:grid-cols-3" data-testid="testimonials-grid">
          {testimonials.map((t, i) => (
            <Reveal key={t.id || t.name} delay={i * 0.1}>
              <figure
                data-testid={`testimonial-card-${i}`}
                className="group relative h-full rounded-3xl border border-border bg-white p-7 transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1.5 hover:border-gold/40 hover:shadow-[0_20px_50px_rgba(10,41,30,0.1)]"
              >
                <Quote className="h-7 w-7 text-gold/50 transition-colors duration-300 group-hover:text-gold" />
                <blockquote className="mt-4 font-editorial text-[17px] italic leading-relaxed text-forest-deep">
                  “{t.quote}”
                </blockquote>
                <figcaption className="mt-6 flex items-center justify-between border-t border-border pt-5">
                  <div>
                    <p className="font-display text-sm font-bold text-forest-deep">{t.name}</p>
                    <p className="mt-0.5 text-xs text-muted-foreground">{t.role}</p>
                  </div>
                  <div className="flex gap-0.5">
                    {[...Array(5)].map((_, s) => (
                      <Star key={s} className="h-3 w-3 fill-gold text-gold" />
                    ))}
                  </div>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
